<script lang="ts">
/** Clause option tiers this chip can render — adapt backend enums via
    statusMaps.clauseTierMap. */
export type GaiaClauseTier = 'preferred' | 'fallback' | 'escalation';
</script>

<script setup lang="ts">
import { computed, type PropType } from 'vue';
import GaiaRiskPill, { type GaiaRiskLevel } from '../base/GaiaRiskPill.vue';

const props = defineProps({
  tier: {
    type: String as PropType<GaiaClauseTier>,
    required: true,
  },
  /** Fully rounded form; default is the radius-8 card chip. */
  pill: {
    type: Boolean,
    default: false,
  },
});

// The tier chips share the risk palette: preferred reads green, fallback
// amber, escalation red — mapped here so the tier vocabulary stays its own.
const tierLevel: Record<GaiaClauseTier, GaiaRiskLevel> = {
  preferred: 'low',
  fallback: 'medium',
  escalation: 'high',
};

const level = computed(() => tierLevel[props.tier]);
</script>

<template>
  <!-- Tier chip on a clause position (Playbooks mock: Preferred position /
       Acceptable fallback / Escalation required when). -->
  <gaia-risk-pill :level="level" :pill="props.pill"><slot /></gaia-risk-pill>
</template>
